module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_activity_automation-small-d883139f5596d6302a0cb323ed8a0e1a.png";